const BUSINESS_SLUGS = {
  RESTAURANT: 'restaurant',
  COFFEE: 'coffee',
  DIET: 'diet',
  HOSPITAL: 'hospital',
  HOTEL: 'hotel',
  SALON: 'salon',
  SHOWROOM: 'showroom',
  FOOD_TRUCK: 'foodtruck',
  COMPANIES: 'companies',
  CATERING: 'catering',
}

export default BUSINESS_SLUGS

export const BUSINESS_FEATURES = {
  ASSIGN_TABLE: 'assign_table',
  CALORIES: 'calories',
  CAR_PICKUP: 'car_pickup',
  CHEF: 'chef',
  COUPONS: 'coupons',
  PROMOTIONS: 'promotions',
  DELIVERY: 'delivery',
  DINE_IN: 'dine_in',
  DISCOUNTS: 'discounts',
  WALLET_PACKAGES: 'wallet_packages',
  INGREDIENTS: 'ingredients',
  KITCHEN: 'kitchen',
  MODIFIERS: 'modifiers',
  PREPARATION_TIME: 'preparation_time',
  QUEUE: 'queue',
  RESERVE_TABLE: 'reserve_table',
  STICKERS: 'stickers',
  STOCK: 'stock',
  SUBSCRIPTION: 'subscription',
  SUPERVISOR: 'supervisor',
  WAITER: 'waiter',
}

export const BUSINESS_FEATURES_STEPS: any = {
  dine_in: [BUSINESS_FEATURES.DINE_IN, BUSINESS_FEATURES.ASSIGN_TABLE],
  delivery: [BUSINESS_FEATURES.DELIVERY],
  add_modifier: [BUSINESS_FEATURES.MODIFIERS],
  show_modifiers: [BUSINESS_FEATURES.MODIFIERS],
  queue: [BUSINESS_FEATURES.QUEUE],
  reservation: [BUSINESS_FEATURES.RESERVE_TABLE],
  coupons: [BUSINESS_FEATURES.COUPONS],
  coupons_list: [BUSINESS_FEATURES.COUPONS],
  discounts: [BUSINESS_FEATURES.DISCOUNTS],
  discounts_list: [BUSINESS_FEATURES.DISCOUNTS],
}

export const LABELS_KEYS = ['floor_label', 'table_label', 'kitchen_label']
